import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IntegrationFilterState {
  showHiddenApps: boolean;
  searchQuery: string;
  selectedTypes: string;
}

const initialState: IntegrationFilterState = {
  showHiddenApps: false,
  searchQuery: '',
  selectedTypes: '',
};

const integrationSearchToggelFilterSlice = createSlice({
  name: 'integrationSearchToggelFilter',
  initialState,
  reducers: {
    setShowHiddenApps(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showHiddenApps: action.payload,
      };
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      return {
        ...state,
        searchQuery: action.payload,
      };
    },
    setSelectedTypes(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedTypes: action.payload,
      };
    },
    resetIntegrationSearchToggelFilter: () => initialState,
  },
});

export const {
  setShowHiddenApps,
  setSearchQuery,
  setSelectedTypes,
  resetIntegrationSearchToggelFilter,
} = integrationSearchToggelFilterSlice.actions;

export type { IntegrationFilterState };
export default integrationSearchToggelFilterSlice;
